import { FunctionComponent, HTMLAttributes } from 'react';

import styles from './iconWrapper.module.css';
import { useModifiers } from 'hooks/useModifiers';

interface IconWrapperProps extends HTMLAttributes<HTMLDivElement> {
    color?: 'regular' | 'success' | 'danger';
}

export const IconWrapper: FunctionComponent<IconWrapperProps> = ({ color = 'regular', ...rest }) => {
    const mods = useModifiers(styles, 'iconWrapper', {
        [color]: true,
    });

    return <div className={`${styles.iconWrapper} ${mods}`} {...rest} />;
};
